import {Droppable, Plugins} from '@shopify/draggable';

import SoundFx from '../../../components/SoundFx';

export default function BasicsSection() {
  const containerSelector = '.CubesFrame--idBasics';
  const containers = document.querySelectorAll(containerSelector);
  const draggable = new Droppable(containers, {
    dropzone: '.Cube--typeDropzone',
    mirror: {
      appendTo: containerSelector,
    },
    plugins: [Plugins.Snappable],
  });

  // --- Drag states --- //
  const state = {
    justLifted: false,
    snappedIn: false,
    snappedOut: false,
  };

  let initialDropzone = null;

  draggable.on('drag:start', (evt) => {
    SoundFx.Single.play('cubeUp');
    state.justLifted = true;
    initialDropzone = evt.source.parentNode;
  });

  draggable.on('drag:stop', () => {
    if (!state.snappedIn) {
      SoundFx.Single.play('cubeDown');
    }

    state.justLifted = false;
    state.snappedIn = false;
    state.snappedOut = false;
  });

  draggable.on('snap:out', () => {
    if (state.justLifted) {
      return;
    }

    SoundFx.Single.play('cubeUp');
    state.snappedIn = false;
    state.snappedOut = true;
  });

  draggable.on('snap:in', (evt) => {
    if (state.snappedIn || evt.snappable.parentNode === initialDropzone) {
      evt.cancel();
      return;
    }

    SoundFx.Single.play('cubeDown');
    state.justLifted = false;
    state.snappedIn = true;

    initialDropzone = null;
  });

  draggable.on('drag:over', (evt) => {
    if (evt.source.id === 'BasicsCube10' && evt.over.id === 'BasicsCube11') {
      evt.cancel();
    }

    if (evt.source.id === 'BasicsCube11' && evt.over.id === 'BasicsCube10') {
      evt.cancel();
    }
  });

  draggable.on('droppable:dropped', (evt) => {
    if (evt.dragEvent.source.id === 'BasicsCube10' && evt.dropzone.id === 'BasicsCube3') {
      evt.cancel();
    }

    if (evt.dragEvent.source.id === 'BasicsCube11' && evt.dropzone.id === 'BasicsCube7') {
      evt.cancel();
    }
  });

  return draggable;
}
